export default "__VITE_ASSET__Dxc5cx52__"